import duck from "../assets/duck.png";
import duckLogo from "../assets/duckLogo.png";
import duckLeft from "../assets/duckLeft.png";
import entencupTitle from "../assets/Entencup.png";
import Footer from "./Footer";
import useSeasonDetails from "../hooks/useSeasonDetails";
import Section from "./Section";

function renderSections(sections) {
    if (!Array.isArray(sections)) return null;
    return sections.map((s, i) => <Section key={i} {...s} />);
}

function bandContent(band, fallback) {
    if (!band) return fallback;
    return (
        <>
            {band.children}
            {renderSections(band.sections)}
        </>
    );
}

function hasBandContent(band) {
    if (!band) return false;
    if (band.children) return true;
    if (!Array.isArray(band.sections) || band.sections.length === 0) return false;
    return band.sections.some((s) => s.show !== false);
}

const DUCK_SCALE = 1.5;

const WAVE_VIEWBOX = "0 0 1440 320";

function everySecondRightWaveFill(_rightWaveIndex, defaultFill) {
    return defaultFill;
}

function WavePath({ fill, d }) {
    return (
        <path
            fill={fill}
            stroke={fill}
            strokeWidth="4"
            d={d}
        />
    );
}

function scaledDuck(href, x, y, width, height) {
    const w = width * DUCK_SCALE;
    const h = height * DUCK_SCALE;
    return (
        <image
            href={href}
            x={x - (w - width) / 2}
            y={y - (h - height) / 2}
            width={w}
            height={h}
        />
    );
}

function DuckSvg({ children, className = "absolute -bottom-8 w-full" }) {
    return (
        <div className={`${className} pointer-events-none z-50 overflow-visible`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox={WAVE_VIEWBOX}
                preserveAspectRatio="none"
                overflow="visible"
                className="block w-full h-auto overflow-visible"
            >
                {children}
            </svg>
        </div>
    );
}

function WaveToLightBand({ rightWaveIndex }) {
    return (
        <div className="bg-blue-dark relative overflow-hidden z-40">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 90 1440 230" className="block w-full h-auto">
                <path fill={everySecondRightWaveFill(rightWaveIndex, "#1d378a")} fillOpacity="1" d="M0,192L80,186.7C160,181,320,171,480,176C640,181,800,203,960,186.7C1120,171,1280,117,1360,90.7L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" />
                <path fill="#36a7dc" fillOpacity="1" d="M0,160L80,154.7C160,149,320,139,480,160C640,181,800,235,960,245.3C1120,256,1280,224,1360,208L1440,192L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" />
                {scaledDuck(duckLeft, 1100, 132, 150, 150)}
            </svg>
        </div>
    );
}

function WaveToMediumBand({ rightWaveIndex }) {
    return (
        <div className="bg-blue-light relative overflow-hidden z-40">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 90 1440 230" className="block w-full h-auto">
                <path fill={everySecondRightWaveFill(rightWaveIndex, "#18245c")} fillOpacity="1" d="M0,192L80,186.7C160,181,320,171,480,176C640,181,800,203,960,186.7C1120,171,1280,117,1360,90.7L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" />
                <path fill="#1d378a" fillOpacity="1" d="M0,160L80,154.7C160,149,320,139,480,160C640,181,800,235,960,245.3C1120,256,1280,224,1360,208L1440,192L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" />
                {scaledDuck(duckLeft, 1230, 132, 150, 150)}
            </svg>
        </div>
    );
}

function WaveDarkToMediumBand({ rightWaveIndex }) {
    return (
        <div className="bg-blue-dark relative overflow-hidden z-40">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 90 1440 230" className="block w-full h-auto">
                <path fill={everySecondRightWaveFill(rightWaveIndex, "#18245c")} fillOpacity="1" d="M0,192L80,186.7C160,181,320,171,480,176C640,181,800,203,960,186.7C1120,171,1280,117,1360,90.7L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" />
                <path fill="#1d378a" fillOpacity="1" d="M0,160L80,154.7C160,149,320,139,480,160C640,181,800,235,960,245.3C1120,256,1280,224,1360,208L1440,192L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" />
                {scaledDuck(duckLeft, 1100, 132, 150, 150)}
            </svg>
        </div>
    );
}

function WaveMediumToDarkBand() {
    return (
        <div className="bg-blue-medium relative overflow-hidden z-40">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 160 1440 160" className="block w-full h-auto">
                <path fill="#18245c" fillOpacity="1" d="M0,192L80,186.7C160,181,320,171,480,176C640,181,800,203,960,186.7C1120,171,1280,117,1360,90.7L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" />
                <path fill="#18245c" fillOpacity="1" d="M0,160L80,154.7C160,149,320,139,480,160C640,181,800,235,960,245.3C1120,256,1280,224,1360,208L1440,192L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" />
            </svg>
        </div>
    );
}


function BgHolder(props) {
    const { data } = useSeasonDetails();
    const bands = props.bands;
    const s1 = bands ? bandContent(bands[0]) : props.s1;
    const s2 = bands ? bandContent(bands[1]) : props.s2;
    const s3 = bands ? bandContent(bands[2]) : props.s3;

    const has2 = bands ? hasBandContent(bands[1]) : !!props.s2;
    const has3 = bands ? hasBandContent(bands[2]) : !!props.s3;

    const nextAfterBand1 = has2 ? 1 : has3 ? 2 : -1;
    const showWaveAfterBand2 = has2 && has3;
    const showWaveAfterBand2ToFooter = has2 && !has3;

    let rightWaveIndex = 0;
    const heroRightWaveIndex = rightWaveIndex++;
    const afterBand1RightWaveIndex = nextAfterBand1 !== -1 ? rightWaveIndex++ : null;
    const afterBand2RightWaveIndex = showWaveAfterBand2 ? rightWaveIndex++ : null;

    return (
        <div className="w-full">
            <div className="h-screen/2 relative overflow-visible">
                <div className="absolute inset-0 overflow-hidden">
                    <picture className="block h-full w-full">
                        <source
                            media="(max-width: 767px)"
                            srcSet={props.mainImageMobile || props.mainImage}
                        />
                        <img
                            src={props.mainImage}
                            alt="Background"
                            className="h-full w-full bg-auto object-cover object-[82%_100%] sm:object-[85%_100%] lg:object-[88%_100%]"
                        />
                    </picture>
                </div>
                <div className="absolute bottom-0 lg:-bottom-16 inset-x-0 leading-none -translate-y-px pointer-events-none z-10">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox={WAVE_VIEWBOX}
                        preserveAspectRatio="none"
                        className="block w-full h-auto"
                    >
                        <WavePath fill={everySecondRightWaveFill(heroRightWaveIndex, "#1d378a")} d="M0,192L80,186.7C160,181,320,171,480,176C640,181,800,203,960,186.7C1120,171,1280,117,1360,90.7L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" />
                        <WavePath fill="#18245c" d="M0,160L80,154.7C160,149,320,139,480,160C640,181,800,235,960,245.3C1120,256,1280,224,1360,208L1440,192L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" />
                    </svg>
                </div>
                <DuckSvg className="absolute bottom-0 lg:-bottom-16 inset-x-0 leading-none -translate-y-px">
                    {scaledDuck(duckLeft, 1180, 80, 150, 150)}
                </DuckSvg>
            </div>
            <section className="w-full bg-blue-dark lg:pt-16">
                <div className="w-full md:w-4/5 m-auto flex flex-col sm:flex-row items-start sm:items-center justify-start gap-4 md:gap-6 px-4 pt-8 md:pt-12 pb-16 md:pb-24">
                    <img
                        src={duck}
                        alt="Duck"
                        width={203}
                        height={192}
                        className="shrink-0 object-contain w-auto h-auto max-w-[min(100%,203px)] max-h-[min(192px,45vw)]"
                    />
                    <div className="flex flex-col justify-center text-white text-left textShadow min-w-0 w-full sm:w-auto flex-1">
                        <div className="hero-title-text font-bold leading-none tracking-wide mt-1">
                            {data?.["entencup-number"]}. DRESDNER
                        </div>
                        <img
                            src={entencupTitle}
                            alt="Entencup"
                            width={1303}
                            height={195}
                            className="mt-2 self-start w-auto max-w-[min(100%,1303px)] max-h-[195px] h-auto object-contain object-left"
                        />
                    </div>
                </div>
                <div className="relative w-4/5 m-auto pb-24 md:pb-20 lg:pb-48 z-50">
                    {s1}
                </div>
                {nextAfterBand1 === 1 && showWaveAfterBand2 && <WaveToLightBand rightWaveIndex={afterBand1RightWaveIndex} />}
                {nextAfterBand1 === 1 && !showWaveAfterBand2 && <WaveDarkToMediumBand rightWaveIndex={afterBand1RightWaveIndex} />}
                {nextAfterBand1 === 2 && <WaveDarkToMediumBand rightWaveIndex={afterBand1RightWaveIndex} />}
            </section>
            {has2 && (
            <section className="">
                <div className={showWaveAfterBand2 ? "bg-blue-light" : "bg-blue-medium"}>

                    <div
                        className={[
                            "relative w-4/5 m-auto pt-16 lg:pt-8 z-50",
                            showWaveAfterBand2ToFooter ? "pb-24 md:pb-32 lg:pb-48" : "pb-12 lg:pb-48",
                        ].join(" ")}
                    >
                        {s2}
                    </div>
                    {showWaveAfterBand2 && <WaveToMediumBand rightWaveIndex={afterBand2RightWaveIndex} />}
                    {showWaveAfterBand2ToFooter && <WaveMediumToDarkBand />}

                </div>
            </section>
            )}
            {has3 && (
            <section>
                <div className="bg-blue-medium relative overflow-visible z-40">
                    <DuckSvg>
                        {scaledDuck(duckLogo, 780, 145, 170, 170)}
                        {scaledDuck(duckLeft, 1150, 145, 160, 160)}
                    </DuckSvg>
                    <div className="relative w-4/5 m-auto pb-12 lg:pb-48 pt-16 lg:pt-24 z-50">
                        {s3}
                    </div>
                    <WaveMediumToDarkBand />
                </div>
            </section>
            )}
            <section>
                <div className="bg-blue-dark">
                    <Footer />
                </div>
            </section>


        </div>
    );
}

export default BgHolder;
